<template>
    <el-container>
        <el-header>
            <!-- <h1>代理商录入界面</h1> -->
        </el-header>
        <el-main>
            <el-row>
                <el-col :span="12">
                    <div class="grid-content bg-purple" style="display: flex;">
                        <el-input placeholder="请输入子账户名称" v-model="input" style="width: 250px;" clearable></el-input>
                        <div style="margin-left: 10px;"><el-button type="primary" icon="el-icon-search" plain
                                @click="selectdxb">查询</el-button></div>
                        <div><el-button type="primary" plain @click="opendialog">新增代理商</el-button>
                        </div>
                        <div><el-button type="primary" icon="el-icon-upload" plain @click="openDialog">批量导入</el-button>
                        </div>
                        <div><el-button type="danger" icon="el-icon-delete-solid" plain
                                :disabled="multipleSelection.length === 0" @click="deleteSelected">删除所选</el-button></div>
                        <div><el-button icon="el-icon-download" plain type="primary"
                                @click="downloadTemplate">下载录入模板</el-button></div>

                    </div>

                </el-col>

                <el-col :span="8">


                </el-col>
                <el-col :span="6">
                    <!-- <div class="grid-content bg-purple-light"></div> -->
                </el-col>
            </el-row>


            <el-table border ref="multipleTable" :data="dingxiangbaoData" style="width: 100%; margin-top: 30px;"
                @selection-change="handleSelectionChange">

                <el-table-column type="selection" width="55"></el-table-column>

                <el-table-column prop="dlsname" label="子账户名称"></el-table-column>
                <el-table-column prop="dlsownerid" label="代理商ownerid"></el-table-column>
                <el-table-column prop="dlsapiid" label="代理商apiid"></el-table-column>
                <el-table-column prop="dlsapikey" label="代理商apikey"></el-table-column>
                <el-table-column prop="zownerid" label="子账户ownerid"></el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="editdxbao(scope.row)" plain icon="el-icon-edit">修改</el-button>

                        <el-popconfirm title="确定删除吗？" confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info"
                            icon-color="red" @confirm="deletedxb(scope.row)">
                            <el-button slot="reference" type="danger" icon="el-icon-delete" plain>删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  @current-change="handleCurrentChange"
                :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="total">
            </el-pagination>

        </el-main>
        <el-dialog title="" :visible.sync="creativeMaterials" width="1160px" append-to-body @close="closebiaodan">
            <div class="m-header" style="height: 550px;overflow-y: auto;">
                <el-form :model="form" label-position="right" class="demo-ruleForm">
                    <div class="adgroup-item2">录入子账户</div>

                    <el-form-item label="子账户名称" prop="pkgname" label-width="152px">
                        <el-input v-model="form.dlsname" maxlength="200" placeholder="请输入代理商名" clearable
                            style="width: 100%;"></el-input>
                    </el-form-item>

                    <el-form-item label="代理商ownerid" prop="ownerid" label-width="152px">
                        <el-input v-model="form.dlsownerid" maxlength="200" placeholder="请输入代理商ownerid" clearable
                            style="width: 100%;"></el-input>
                    </el-form-item>

                    <el-form-item label="代理商apiid" prop="apiid" label-width="152px">
                        <el-input v-model="form.dlsapiid" maxlength="200" placeholder="请输入代理商apiid" clearable
                            style="width: 100%;"></el-input>
                    </el-form-item>

                    <el-form-item label="代理商apikey" prop="apikey" label-width="152px">
                        <el-input v-model="form.dlsapikey" maxlength="200" placeholder="请输入代理商apikey" clearable
                            style="width: 100%;"></el-input>
                    </el-form-item>

                    <el-form-item label="子账户ownerid" prop="zownerid" label-width="152px">
                        <el-input v-model="form.zownerid" maxlength="200" placeholder="请输入子账户ownerid" clearable
                            style="width: 100%;"></el-input>
                    </el-form-item>
                </el-form>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="creativeMaterials = false">取 消</el-button>
                <el-button type="primary" @click="postdingxiang">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="" :visible.sync="creativeMaterialsedit" width="1160px" append-to-body @close="closebiaodan">
            <div class="m-header" style="height: 550px;overflow-y: auto;">
                <el-form :model="form2" label-position="right" class="demo-ruleForm">
                    <div data-v-da9757c6="" class="adgroup-item2">修改代理商</div>
                    <el-form-item label="代理商名" prop="pkgname" label-width="152px">
                        <el-input v-model="form2.dlsname" style="width: 400px;" maxlength="200" placeholder="请输入代理商名"
                            clearable></el-input>
                    </el-form-item>

                    <el-form-item label="代理商ownerid" prop="ownerid" label-width="152px">
                        <el-input v-model="form2.dlsownerid" style="width: 400px;" maxlength="200"
                            placeholder="请输入代理商ownerid" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="代理商apiid" prop="apiid" label-width="152px">
                        <el-input v-model="form2.dlsapiid" style="width: 400px;" maxlength="200" placeholder="请输入代理商apiid"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="代理商apikey" prop="apikey" label-width="152px">
                        <el-input v-model="form2.dlsapikey" style="width: 400px;" maxlength="200" placeholder="请输入代理商apikey"
                            clearable></el-input>
                    </el-form-item>
                    <el-form-item label="子账户ownerid" prop="apikey" label-width="152px">
                        <el-input v-model="form2.zownerid" style="width: 400px;" maxlength="200" placeholder="请输入子账户ownerid"
                            clearable></el-input>
                    </el-form-item>




                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="creativeMaterialsedit = false">取 消</el-button>
                <el-button type="primary" @click="postdingxiang2">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="批量导入" :visible.sync="dialogVisible" width="50%">


            <!-- 文件上传组件 -->
            <el-upload class="upload-demo" :auto-upload="false" action="#" :on-change="handleFileChange" :show-file-list="false"
                accept=".xlsx,.xls,.csv" drag>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                    只能上传xlsx/xls文件，且必须包含以下列：<br>
                    dlsname(代理商名称), dlsownerid, dlsapiid, dlsapikey, zownerid
                </div>
            </el-upload>

            <!-- 预览表格 -->
            <el-table v-if="importData.length > 0" :data="importData" border style="width: 100%; margin-top: 20px;">
                <el-table-column prop="dlsname" label="代理商名称"></el-table-column>
                <el-table-column prop="dlsownerid" label="渠道ID"></el-table-column>
                <el-table-column prop="dlsapiid" label="API ID"></el-table-column>
                <el-table-column prop="dlsapikey" label="API Key"></el-table-column>
                <el-table-column prop="zownerid" label="Zowner ID"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitImport" :disabled="importData.length === 0">
                    确 定 (已导入 {{ importData.length }} 条数据)
                </el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
import axios from "axios";
import * as XLSX from 'xlsx';


export default {
    data() {
        return {
            multipleSelection: [],
            userId: '',
            total: 0,
            pageNum: 1,
            pageSize: 10,
            dialogVisible: false,
            importData: [], // 存储解析后的数据
            file: null, // 存储上传的文件
            dingxiangbaoData: [],
            regionOptions: [],
            selectedRegions: [],
            checkShow: '',
            input: '',
            creativeMaterials: false,

            loading: false,
            props: {
                value: 'code',
                label: 'name',
                children: 'children',
                multiple: true,
                emitPath: false
            },
            form: {
               

            },
            form2: {


            },


            creativeMaterialsedit: false,
            editform: {
                id: '',
               

            }
        };
    },
    created() {
        this.userId = this.$route.query.userId

        if (!this.userId) {
            // 使用Element UI的消息提示
            this.$message.warning('您得先登录')

            // 设置延迟跳转让用户看到提示
            setTimeout(() => {
                // 重定向到登录页面（外部链接）
                window.location.href = 'https://control.zjwec.cn/page/end/login.html'
            }, 1500)  // 1.5秒后跳转

            // 终止后续执行
        }
        this.getdingixnagbaolist()
    },
    watch: {

    },
    methods: {
        downloadTemplate() {
            // 1. 构造表头数据
            const header = [
                ['子账户名称', '代理商ownerid', '代理商apiid', '代理商apikey', '子账户ownerid']
            ];

            // 2. 创建工作表和工作簿
            const worksheet = XLSX.utils.aoa_to_sheet(header);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '模板');

            // 3. 写入并生成 Blob
            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            // 4. 触发下载
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, '代理商模板.xlsx');
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            axios.get('https://control.zjwec.cn/oppo/monitor/page', { params: { pageNum: val, pageSize: this.pageSize, userid: this.userId } }).then(res => {

                this.dingxiangbaoData = res.data.data.records
                this.total = res.data.data.total
                this.pageNum = res.data.data.pages
            })
        },
        deleteSelected() {
            if (this.multipleSelection.length === 0) return;

            this.$confirm(
                `确定删除选中的 ${this.multipleSelection.length} 条记录吗？`,
                '批量删除',
                { type: 'warning' }
            ).then(() => {
                const deleteList = this.multipleSelection.map(item => (item.id));
                axios.post('https://control.zjwec.cn/oppo/monitor/deleteBatch', deleteList)
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getdingixnagbaolist();              // 重新拉取表格数据
                            this.$refs.multipleTable.clearSelection(); // 清除选中状态
                        } else {
                            this.$message.error('提交失败: ' + (err.response.data.message || err.message));
                            console.error(err);
                        }

                    })
                    .catch(err => {
                        this.$message.error('提交失败: ' + (err.response.data.message || err.message));
                        console.error(err);
                    });
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        openDialog() {
            this.dialogVisible = true;
            this.importData = []; // 清空之前的数据
            this.file = null;
        },

        // 文件选择变化时触发
        handleFileChange(file) {
            const isExcel = file.name.endsWith('.xlsx') ||
                file.name.endsWith('.xls') ||
                file.name.endsWith('.csv');

            if (!isExcel) {
                this.$message.error('只能上传Excel文件!');
                return;
            }

            this.file = file;
            this.parseExcel(file.raw);
        },

        // 解析Excel文件
        parseExcel(file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheetName];

                    // 将工作表转换为JSON
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);

                    // 中文列名 => 英文字段映射
                    const fieldMap = {
                        '子账户名称': 'dlsname',
                        '代理商ownerid': 'dlsownerid',
                        '代理商apiid': 'dlsapiid',
                        '代理商apikey': 'dlsapikey',
                        '子账户ownerid': 'zownerid'
                    };

                    // 转换数据格式
                    this.importData = jsonData.map(item => {
                        const result = {};

                        for (const [chineseKey, fieldName] of Object.entries(fieldMap)) {
                            result[fieldName] = item[chineseKey] || '';
                        }

                        // 添加默认值
                        result.media = 'oppo';
                        result.userid = this.userId;

                        return result;
                    });

                    this.$message.success(`成功解析 ${this.importData.length} 条数据`);
                } catch (error) {
                    this.$message.error('解析Excel文件失败: ' + error.message);
                    console.error('解析错误:', error);
                }
            };

            reader.readAsArrayBuffer(file);
        }
        ,

        // 提交导入
        submitImport() {
            if (this.importData.length === 0) {
                this.$message.warning('没有可导入的数据');
                return;
            }
            axios.post('https://control.zjwec.cn/oppo/monitor/addBatch', this.importData)
                .then(res => {
                    if (res.data.code == 0) {
                        this.$message.success('录入成功');
                        // 清空 form 等状态
                        this.form = {
                            dlsname: '',
                            dlsownerid: '',
                            dlsapiid: '',
                            dlsapikey: '',
                            zownerid: '',
                            media: "oppo",
                            userid: ''
                        };

                        this.getdingixnagbaolist();
                        this.dialogVisible = false;
                        this.importData = [];
                    } else {
                        this.$message.error('提交失败: ' + (err.response.data.message || err.message));
                        console.error(err);
                    }

                })
                .catch(err => {
                    this.$message.error('提交失败: ' + (err.response.data.message || err.message));
                    console.error(err);
                });





        },
        async selectdxb() {

            try {
                // 调用删除接口
                const res = await axios.get('https://control.zjwec.cn/oppo/monitor/page', {
                    params: { pageNum: this.pageNum, pageSize: this.pageSize, dlsname: this.input, userid: this.userId, } // 替换为你的参数
                }).then(res => {
                    // if(res.data)

                    if (res.data.code < 0) {
                        this.$message.error('查询失败: ' + res.data.msg);
                        return
                    }

                    this.dingxiangbaoData = res.data.data.records
                    this.$message.success('查询成功');
                });

            } catch (error) {
                console.error('查询失败:', error);
                this.$message.error('查询失败: ' + res.data.msg);
            }
        },
        editdxbao(params) {
            this.creativeMaterialsedit = true

            this.form2 = { ...params }

        },
        async deletedxb(row) {

            try {
                // 调用删除接口
                const res = await axios.delete(`https://control.zjwec.cn/oppo/monitor/delete/${row.id}`, {
                    // params: { id: row.id } // 替换为你的参数
                });
                if (res.data.code == 0) {
                    this.$message.success('删除成功');
                    this.getdingixnagbaolist()
                } else {

                    this.$message.error('删除失败: ');
                    this.getdingixnagbaolist()
                }

                // this.$emit('deleted'); // 触发事件通知父组件
            } catch (error) {

                this.$message.error('删除失败: ');
                this.getdingixnagbaolist()
            }
        },
        getdingixnagbaolist() {
            axios.get('https://control.zjwec.cn/oppo/monitor/page', { params: { pageNum: this.pageNum, pageSize: this.pageSize, userid: this.userId } }).then(res => {

                this.dingxiangbaoData = res.data.data.records
                this.total = res.data.data.total
            })
        },
        closebiaodan() {
            this.form = {
                dlsname: '',
                dlsownerid: '',
                dlsapiid: '',
                dlsapikey: '',
                zownerid: '',
                media: "oppo",
                userid: '',
            }


        },
        closebiaodanedit() {

            this.creativeMaterialsedit = false
        },
        postdingxiang() {
            if (
                !this.form.dlsname ||
                !this.form.dlsownerid ||
                !this.form.dlsapiid ||
                !this.form.dlsapikey ||
                !this.form.zownerid
                // !this.form.media ||
                // !this.form.userid
            ) {
                console.error('错误：所有字段不能为空！');
                this.$message.error('请填写所有必填字段！');
                return; // 终止提交
            }

            this.form = { ...this.form, userid: this.userId }


            axios.post('https://control.zjwec.cn/oppo/monitor/add', {
                ...this.form
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success('录入成功')
                    this.form = {
                        dlsname: '',
                        dlsownerid: '',
                        dlsapiid: '',
                        dlsapikey: '',
                        zownerid: '',
                        media: "oppo",
                        userid: '',
                    }
                    this.getdingixnagbaolist()
                    this.creativeMaterials = false
                } else {
                    // 失败逻辑
                    this.$message.error(res.data.msg || '操作失败');
                }


            })
        },
        postdingxiang2() {


            if (
                !this.form2.dlsname ||
                !this.form2.dlsownerid ||
                !this.form2.dlsapiid ||
                !this.form2.dlsapikey ||
                !this.form2.zownerid
                // !this.form.media ||
                // !this.form.userid
            ) {
                console.error('错误：所有字段不能为空！');
                this.$message.error('请填写所有必填字段！');
                return; // 终止提交
            }




            axios.put('https://control.zjwec.cn/oppo/monitor/update', {
                ...this.form2
            }).then(res => {
                if (res.data.code == 0) {
                    this.$message.success('修改成功')
                    this.form2 = {
                        dlsname: '',
                        dlsownerid: '',
                        dlsapiid: '',
                        dlsapikey: '',
                        zownerid: '',
                        media: "oppo",
                        userid: '',
                    }
                    this.getdingixnagbaolist()
                    this.creativeMaterialsedit = false
                } else {
                    // 失败逻辑
                    this.$message.error(res.data.msg || '操作失败');
                }


            })
        },

        opendialog() {
            this.creativeMaterials = true
        },
    },

};
</script>

<style scoped>
.timeRange {
    user-select: none;
    position: relative;
    padding: 10px 0;

    .calendar {
        display: inline-block;
    }

    table {
        width: 100%;
        border-radius: 4px;
        border-spacing: 0;
        table-layout: fixed;
        border-collapse: collapse;

        thead {

            th,
            td {
                height: 30px;
            }

            th {
                padding: 5px 0;

            }

            .weekRow {
                width: 100px;
                min-width: 100px;
                padding: 20px 0
            }
        }

        td,
        th {
            outline: 0;
            border: 1px solid #E3E3E3;
            font-size: 12px;
            text-align: center;
            min-width: 11px;
            line-height: 1.6em;
            min-width: 24px;
        }

        tbody {
            position: relative;
            overflow: hidden;

            td {
                height: 20px !important;
            }
        }

        td.active {
            background: hsl(207, 97%, 49%);
        }
    }

    .table-core {
        line-height: 2.4em;
        border: 1px solid #E3E3E3;
        border-top: 0;
        overflow: hidden;
        padding: 10px;

        .clearfix {
            color: #8A8A8A;
            text-align: left;
            height: 22px;
            line-height: 22px;
            margin: 8px 0;
            display: flex;
            font-size: 12px;

            .clearBtn {
                cursor: pointer;
                color: #5775F9;
                font-size: 14px;
                margin-left: auto;
            }
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                display: flex;
                align-items: center;
                line-height: 24px;
                margin-bottom: 8px;
                padding: 4px 0;

                label {
                    display: inline-block;
                    min-width: 60px;
                    color: #475569;
                    text-align: left;
                    font-weight: 500;
                    font-size: 13px;
                }

                span {
                    font-size: 13px;
                    background-color: #f1f5f9;
                    padding: 2px 8px;
                    border-radius: 4px;
                    margin-right: 6px;
                    color: #334155;

                    &::after {
                        display: none;
                    }
                }
            }
        }

    }

    #box {
        background: rgba(241, 1, 85, 0.4);
        pointer-events: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
    }
}

#box {
    background: rgba(241, 1, 85, 0.4);
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
}




.checkIndex {
    padding: 20px;
    height: 600px;
    overflow: auto;
}

.checkView {
    margin-bottom: 20px;
    border: 1px solid #eee;
    padding: 10px;
    border-radius: 4px;
    display: flex;

}

.address {
    display: inline-block;
    margin-left: 10px;
}

.mobileCehck {
    margin-top: 10px;
}

.select-container {
    width: 100%;
    height: 100%;
    background: #f5f5f5;
}

.plan-container {
    text-align: left;
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-bottom: 50px;
}

.el-form-item__label {
    margin-right: 50px;
}

.demo-ruleForm {
    max-width: 800px;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-radio-group {
    margin-right: 15px;
}

.el-input {
    width: 280px;
}

.el-icon-info {
    color: #409EFF;
    cursor: pointer;
    font-size: 16px;
}

.el-button {
    margin-right: 10px;
}

.adgroup-container {
    padding: 20px;
    background-color: #fff;
}

.adgroup-form {
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
    padding-bottom: 10px;
    /* border-bottom: 1px solid #eee; */
}

.form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 8px;
}

.media-specify-box,
.adslot-specify-box,
.region-custom-box,
.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.region-selection {
    margin-top: 15px;
    max-height: 300px;
    overflow-y: auto;
}

.region-item {
    margin-bottom: 10px;
}

.age-checkbox-group,
.phone-price-group,
.network-group {
    display: inline-block;
    margin-left: 15px;
}


.adgroup-item2 {
    color: #606266;
    line-height: 20px;
    font-size: 12px;
    border-left: 2px solid #606266;
    padding-left: 8px;
    font-family: PingFangSC-Regular;
    margin-top: 40px;
    margin-bottom: 40px;
}

.demo-ruleForm {
    max-width: 1000px;
}

.time-custom-box {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
}
</style>

<style scoped>
.adgroup-item2 {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 24px;
    padding-left: 5px;
    border-left: 4px solid #409EFF;
}

.el-form-item {
    margin-bottom: 22px;
}

.el-input {
    font-size: 14px;
}

.demo-ruleForm {
    background: #fff;
    padding: 30px 40px;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
    max-width: 700px;
    margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/oppo/dlslr.vue